import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineMessage, AiOutlineLineChart, AiOutlineBook, AiOutlineSetting } from 'react-icons/ai';

/**
 * Navigation component for the sidebar navigation links
 * 
 * @param {boolean} isExpanded - Whether the sidebar is expanded
 * @param {string} collapsedWidth - Width class for collapsed sidebar (for consistent alignment)
 */
const Navigation = ({ isExpanded = true, collapsedWidth = "w-[70px]" }) => {
  const location = useLocation();
  
  // Navigation items configuration
  const navItems = [
    {
      path: '/',
      label: 'Talk to Pokket',
      icon: <AiOutlineMessage className="w-5 h-5" />
    },
    {
      path: '/insights',
      label: 'Insights',
      icon: <AiOutlineLineChart className="w-5 h-5" />
    },
    {
      path: '/learn',
      label: 'Assessments',
      icon: <AiOutlineBook className="w-5 h-5" />
    }
  ];
  
  // Add Settings item at the bottom so it will appear right above Help button
  navItems.push({
    path: '/settings',
    label: 'Settings',
    icon: <AiOutlineSetting className="w-5 h-5" />
  });
  
  return (
    <nav className="flex flex-col flex-1">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        
        return (
          <Link 
            key={item.path}
            to={item.path} 
            className={`
              sidebar-item 
              ${isActive ? 'bg-blue-100' : 'hover:bg-gray-200'} 
              flex flex-row items-center relative h-14 mx-2 rounded-xl
            `}
            title={item.label}
          >
            {/* Fixed width container for icon - positioned exactly like the hamburger */}
            <div className={`${collapsedWidth} flex-shrink-0 flex justify-center items-center -ml-2`}>
              {/* Apply immediate color change to icon */}
              <div className={isActive ? 'text-blue-700' : ''}>
                {item.icon}
              </div>
            </div>
            
            {/* Text label with fade-in transition for width/opacity only, not for color */}
            <div 
              className={`
                overflow-hidden
                ${isExpanded ? 'opacity-100 w-auto' : 'opacity-0 w-0 pointer-events-none'}
              `}
              style={{ 
                transitionProperty: 'opacity, width',
                transitionDuration: '300ms',
                transitionTimingFunction: 'ease-in-out',
                transitionDelay: isExpanded ? '150ms' : '0ms'
              }}
            >
              {/* Make text immediately bold and colored when selected without transition */}
              <span className={`text-base whitespace-nowrap ${isActive ? 'font-medium text-blue-700' : 'font-normal'}`}>
                {item.label}
              </span>
            </div>
          </Link>
        );
      })}
    </nav>
  );
};

export default Navigation; 